module.exports = __webpack_public_path__ + "static/media/icon.apollo.black.b5f2e461.png";